import React from 'react';
import PropTypes from 'prop-types';
import { Field } from './styles';

const Input = ({
  className,
  checked,
  disabled,
  max,
  min,
  name,
  onChange,
  placeholder,
  type,
  value,
}) => (
  <Field
    checked={checked}
    className={className}
    disabled={disabled}
    max={max}
    min={min}
    name={name}
    onChange={onChange}
    placeholder={placeholder}
    type={type}
    value={value}
  />
);

Input.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  max: PropTypes.string,
  min: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Input.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  max: '',
  min: '',
  name: '',
  onChange: () => {},
  placeholder: '',
  type: 'text',
  value: '',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js